import {StyledText} from "../../contenful/types";
import {Link} from "react-router-dom";
import React from "react";
import {StyledTextComponent} from "./HeroBannerTwoColumnsComponent";
import {Device} from "../../utils/Device";
import PanelSectionJackpotBanner from "./PanelSectionJackpotBanner";
import { useSelector } from "react-redux";
import { AppState } from "../../RootReducer";


interface Props {
    loggedIn: boolean | undefined;
    id: string | undefined;
    itemLength: number | undefined;
    panels: any;
    sectionClassName: string | undefined;
    renderNavigate: any;

}
type OptionalLinkProps = { children : any, to? : string, className? : string};
const OptionalLink = (props : OptionalLinkProps) => {
    if(props.to) {
        return (
            <Link to={props.to} className={props.className}>
                {props.children}
            </Link>
        )
    } else {
        return <a className={props.className}>{props.children}</a>
    }

}
const PanelSectionFixedWidth: React.FC<Props> = (props : Props) => {
    const isMobile = useSelector((app: AppState)=> app.settings.mobile)

    return (
        <>
        <div className={`panel-section fixed-width ${props.sectionClassName}`}>
            {!isMobile &&
            <div className={`panel-navigate fixed-width`}>
                {props.renderNavigate}
            </div>}
            <div className={`container-fixed-width ${isMobile ? 'mobile': 'desktop'}`}>
                <div className={`panel-wrapper ${isMobile ? 'mobile': 'desktop'}`} id={`${props.id}`} data-items-init={props.itemLength} slide-active={0} data-auto='true'>
                    {props.panels && props.panels.map((panel: any, idx: number) => {

                         let bgImage
                         if(panel.backgroundImage?.fields?.file && panel.backgroundGradient) bgImage = `url('${panel.backgroundImage?.fields?.file?.url}')`
                         if(panel.backgroundImage?.fields?.file && !panel.backgroundGradient) bgImage = `url('${panel.backgroundImage?.fields?.file?.url}')`
                         if(!panel.backgroundImage?.fields?.file && panel.backgroundGradient) bgImage = panel.backgroundGradient
                         if(!panel.backgroundImage?.fields?.file && !panel.backgroundGradient) bgImage = `none`
                        return (
                            <OptionalLink key={idx} to={panel.linkTo}
                                className={`panel-card ${panel.cssClassName ? panel.cssClassName : ''} ${panel.linkTo ? 'link-to' : 'no-link'} ${isMobile ? 'mobile': 'desktop'} ${panel.id ? panel.id : ''}`}>
                                <div className={`panel-inner`} style={{backgroundImage : `${bgImage}`}}>
                                    {panel.icon?.fields?.file &&
                                    <div className={`icon-wrapper`}><img className={`panel-icon`} src={`${panel.icon?.fields?.file?.url}`} alt={`${panel.name ? panel.name : 'panel-icon'}`} /></div>}
                                    {panel.styledTexts && <div className={`text-wrapper`}>
                                        {panel.styledTexts?.map((s : StyledText) => {

                                            return <StyledTextComponent st={s} key={s._id} loggedIn={props.loggedIn}/>
                                        })}
                                        {panel.jackpotId && <PanelSectionJackpotBanner panel={panel}/>}
                                    </div>}
                                </div>
                            </OptionalLink>
                        )
                    })}

                </div>
            </div>
            {!isMobile && <ul className={`splide-pagination`}>
                {props.panels.map((item: any, idx: any) => {
                    return <li key={idx}>
                            <button className={`splide-pagination-page`} type="button"></button>
                        </li>
                    })
                }
            </ul>}
        </div>
        </>
    )
}

export default PanelSectionFixedWidth;
